import { render, staticRenderFns } from "./ManageDocumentsTagsDialog.vue?vue&type=template&id=5915e870&scoped=true"
import script from "./ManageDocumentsTagsDialog.vue?vue&type=script&lang=js"
export * from "./ManageDocumentsTagsDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageDocumentsTagsDialog.vue?vue&type=style&index=0&id=5915e870&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915e870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5915e870')) {
      api.createRecord('5915e870', component.options)
    } else {
      api.reload('5915e870', component.options)
    }
    module.hot.accept("./ManageDocumentsTagsDialog.vue?vue&type=template&id=5915e870&scoped=true", function () {
      api.rerender('5915e870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/document-tags/ManageDocumentsTagsDialog.vue"
export default component.exports